"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byCalfColostrumReplacer = void 0;
const graphql_1 = require("../graphql");
const CustomError_1 = require("./utils/CustomError");
const roundOff_1 = require("./utils/helpers/roundOff");
/**
 * ? Note
 * Here alphabets A, B, C, D, etc. are used as key of the inputs and outputs.
 * These are the identifiers for denoting the fields as mentioned in Excel sheet.
 * All variables names and excel sheet column identifiers are mapped so that it will be easier to check and
 * validate formulas.
 */
const byCalfColostrumReplacer = ({ unit: A, desiredMaxAmtForFirstFeeding: B, desiredMaxAmtForSecondFeeding: C, igGInColostrumReplacer: D, birthBodyWt: E, brixReading: F, brixUsedInPrevCalculation: G, }) => {
    if (B < 2 || B > 5) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    if (C < 1) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    if (C > B) {
        throw new CustomError_1.CustomError('This must be = or less than first feeding');
    }
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary && (E < 50 || E > 130)) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    if (A === graphql_1.Enum_Measurement_System_Enum.Metric && (E < 22 || E > 60)) {
        throw new CustomError_1.CustomError('OUT OF NORMAL RANGE');
    }
    /**
     * Row H Calculation
     */
    const e = B / (B + C);
    const O = A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? E * 1.6666 + 150 : E * 2.2046 * 1.6666 + 150;
    const L = 6.94;
    const M = -96.5;
    let P = 0;
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        P = L * F + M < 0 ? 1 : (L * F + M) * 0.94635;
    }
    else {
        P = L * F + M < 0 ? 0 : L * F + M;
    }
    if (P === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "P"');
    }
    const R = (0, roundOff_1.default)(O / P, 1);
    const X = R > B ? B : R;
    const g = e * O - X * P;
    let h = '';
    if (X === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "X"');
    }
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        h = g / X > 23.65 ? 'USE CR' : 0;
    }
    else {
        h = g / X > 25 ? 'USE CR' : 0;
    }
    if (h === '') {
        throw new CustomError_1.CustomError('Error: Check for field "h"');
    }
    /* Row H */
    let H = '';
    if (h === 0) {
        H = R > B ? B : R;
    }
    else {
        H = h;
    }
    if (H === '') {
        throw new CustomError_1.CustomError('Error: Check for field "H"');
    }
    /**
     * Row I Calculation
     */
    const V = O / P;
    const Y = V > B ? 2 : 1;
    const S = R < B ? 0 : (O - B * P) / P;
    const T = (0, roundOff_1.default)(S, 2) > B ? B : (0, roundOff_1.default)(S, 2);
    const U = T + B - (B + C) < 0 ? 0 : 0.1 + (T + B) - (B + C);
    const Z = R - B;
    const a = O - (O - Z * P);
    let W;
    if (T > C) {
        W = C;
    }
    else {
        W = (0, roundOff_1.default)(S, 1) > B ? B : (0, roundOff_1.default)(S, 1);
    }
    if (W === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "W"');
    }
    const b = W * P;
    const c = (a - b) / Y;
    const Q = A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (D / 100) * 453 : D / 100;
    if (Q === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "Q"');
    }
    let d;
    if (U < 0.01) {
        d = 0;
    }
    else {
        d = c / Q;
        d = A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (0, roundOff_1.default)(d, 2) : (0, roundOff_1.default)(d, 0);
    }
    if (d === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "d"');
    }
    let f;
    const fFieldFormula = Y * d * e;
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        f = (0, roundOff_1.default)(fFieldFormula, 2) > 0 ? (0, roundOff_1.default)(fFieldFormula, 2) : 0;
    }
    else {
        f = (0, roundOff_1.default)(fFieldFormula, 0) > 0 ? (0, roundOff_1.default)(fFieldFormula, 0) : 0;
    }
    if (f === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "f"');
    }
    const i = (e * O) / Q;
    let j = '';
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        j = h === 0 ? f : `ONLY USE CR ${(0, roundOff_1.default)(i, 2)} lb`;
    }
    else {
        j = h === 0 ? (0, roundOff_1.default)(f, 0) : `ONLY USE CR ${(0, roundOff_1.default)(i, 0)} g`;
    }
    if (j === '') {
        throw new CustomError_1.CustomError('Error: Check for field "f"');
    }
    const I = j;
    /**
     * Row J Calculation
     */
    const BO = A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? E * 1.6666 + 150 : E * 2.2046 * 1.6666 + 150;
    const BL = 6.94;
    const BM = -96.5;
    let BP;
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        BP = BL * G + BM < 0 ? 1 : (BL * G + BM) * 0.94635;
    }
    else {
        BP = BL * G + BM < 0 ? 0 : BL * G + BM;
    }
    if (BP === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "BP"');
    }
    let BN;
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        BN = BL * F + BM < 0 ? 1 : (BL * F + BM) * 0.94635;
    }
    else {
        BN = BL * F + BM < 0 ? 0 : BL * F + BM;
    }
    if (BN === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "BN"');
    }
    const BR = (0, roundOff_1.default)(BO / BP, 1);
    const BS = BR < B ? 0 : (BO - B * BP) / BN;
    const BT = (0, roundOff_1.default)(BS, 2) > B ? B : (0, roundOff_1.default)(BS, 2);
    let BW;
    if (BT > C) {
        BW = C;
    }
    else {
        BW = (0, roundOff_1.default)(BS, 1) > B ? B : (0, roundOff_1.default)(BS, 1);
    }
    const BQ = A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (D / 100) * 453 : D / 100;
    const Be = B / (B + C);
    const Bb = BW * BN;
    const BV = BO / BP;
    const BY = BV > B ? 2 : 1;
    const BZ = BR - B;
    const Ba = BO - (BO - BZ * BP);
    const Bc = (Ba - Bb) / BY;
    const BU = BT + B - (B + C) < 0 ? 0 : BT + B - (B + C);
    if (BQ === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "BQ"');
    }
    let Bd;
    if (BU < 0) {
        Bd = 0;
    }
    else {
        Bd =
            A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (0, roundOff_1.default)(Bc / BQ, 2) : (0, roundOff_1.default)(Bc / BQ, 0);
    }
    if (Bd === undefined) {
        throw new CustomError_1.CustomError('Error: Check for field "Bd"');
    }
    const Bf = (0, roundOff_1.default)(BY * Bd * Be, 2) > 0 ? (0, roundOff_1.default)(BY * Bd * Be, 2) : 0;
    const BX = BR > B ? B : BR;
    const Bs = Bf * BQ + BX * BP;
    const Bu = Bs / B;
    const Bn = BW === 0 ? 0 : ((Bu - BP) * BW) / BQ;
    const Bm = BW > 0 ? (Bn * BQ) / BW : 0;
    let Br = '';
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        Br = Bm > 23.65 ? 'USE CR' : BW;
    }
    else {
        Br = Bm / C > 25 ? 'USE CR' : BW;
    }
    if (Br === '') {
        throw new CustomError_1.CustomError('Error: Check for field "Br"');
    }
    const J = Br;
    /**
     * Row K Calculation
     */
    const Bg = Be * BO - BX * BP;
    if (BX === 0) {
        throw new CustomError_1.CustomError('Denominator cannot be 0 Check for field "BX"');
    }
    let Bh = '';
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        Bh = Bg / BX > 23.65 ? 'USE CR' : 0;
    }
    else {
        Bh = Bg / BX > 25 ? 'USE CR' : 0;
    }
    if (Bh === '') {
        throw new CustomError_1.CustomError('Error: Check for field "Bh"');
    }
    const Bk = C / (B + C);
    const Bi = (Bk * BO) / BQ;
    let Bj = '';
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        Bj = Bh === 0 ? Bf : `ONLY USE CR ${(0, roundOff_1.default)(Bi, 2)} Lb`;
    }
    else {
        Bj = Bh === 0 ? (0, roundOff_1.default)(Bf, 0) : `ONLY USE CR ${(0, roundOff_1.default)(Bi, 0)} Lb`;
    }
    if (Bj === '') {
        throw new CustomError_1.CustomError('Error: Check for field "Bj"');
    }
    let Bp = '';
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        Bp = Bm > 23.65 ? 'USE CR' : 0;
    }
    else {
        Bp = Bm > 25 ? 'USE CR' : 0;
    }
    if (Bp === '') {
        throw new CustomError_1.CustomError('Error: Check for field "Bp"');
    }
    const Bo = A === graphql_1.Enum_Measurement_System_Enum.UsCustomary ? (0, roundOff_1.default)(Bn, 2) : (0, roundOff_1.default)(Bn, 0);
    let Bq = '';
    if (A === graphql_1.Enum_Measurement_System_Enum.UsCustomary) {
        Bq = Bp === 0 ? Bo : `ONLY USE CR ${(0, roundOff_1.default)(Bn, 2)} Lb`;
    }
    else {
        Bq = Bp === 0 ? (0, roundOff_1.default)(Bo, 0) : `ONLY USE CR ${(0, roundOff_1.default)(Bn, 0)} g`;
    }
    if (Bq === '') {
        throw new CustomError_1.CustomError('Error: Check for field "Bq"');
    }
    const K = J === 'USE CR' ? Bj : Bq;
    return {
        minAmtNeededInFirstFeeding: H,
        crPowderNeededInFirstFeeding: I,
        amtNeededInSecondFeeding: J,
        amtOfCrUsedInSecondFeeding: K,
    };
};
exports.byCalfColostrumReplacer = byCalfColostrumReplacer;
exports.default = null;
//# sourceMappingURL=byCalfColostrumReplacer.js.map